import { useTranslation } from 'react-i18next'
import { LangText } from '@/components'
import { preFixImgUrl } from '@/utils'
interface ProtocolProps {
  onChange?: (value: boolean) => void
  value?: boolean
}

const Protocol = (props: ProtocolProps) => {
  const { onChange, value } = props;
  const { t } = useTranslation();
  return (
    <div
      className='cursor-pointer text-[#666666] align-middle leading-[22px] '
      style={{ lineHeight: '22px' }}
      onClick={() => onChange?.(!value)}
    >
      {
        value
          ? <img className='w-4 h-4 mr-2 align-middle inline-block' src={preFixImgUrl('395a3e90ef2fd9a614e7b4f74c097f07.png')} />
          : <img className='w-4 h-4 mr-2 align-middle inline-block' src={preFixImgUrl('f0cf9d6693874eb4c9ba3ad941913b07.png')} />
      }
      <LangText lngKey='ce49788a' className='align-middle inline text-[14px]'>{t('ce49788a')}</LangText>
      &nbsp;
      <LangText
        lngKey='75938944'
        className='text-[#FF4D4F] align-middle inline text-[14px]'
        onClick={(e) => { 
          e.stopPropagation();
          window.open('/protocol?id=2', '_blank')
         }}
      >
        {t('75938944')}
      </LangText>
      &nbsp;
      <LangText lngKey='455ee77c' className='align-middle inline text-[14px]'>{t('455ee77c')}</LangText>
      &nbsp;
      <LangText
        lngKey='06b9b593'
        className='text-[#FF4D4F] align-middle inline text-[14px]'
        onClick={(e) => { 
          e.stopPropagation(); 
          window.open('/protocol?id=3', '_blank')
        }}
      >
        {t('06b9b593')}
      </LangText>
    </div>
  )
}

export default Protocol